import axios from "axios";
import API from "../helpers/api";
let searchData = {
    PortName: "",
    Country: "",
    PortType:"",
    PageNumber: 1,
    PageSize: 20
}
/* &PortType=${item.PortType} */
export const getPortList = (item) => {
    let url = `${API.getPortList}?PortName=${item.PortName}&Country=${item.Country}&ZoneId=${item?.Zone > 0 ? item?.Zone : 0}&PageNumber=${item.PageNumber}&PageSize=${item.PageSize}`;
    return dispatch => {
        axios.get(url)
            .then((response) => {
                dispatch({
                    type: "getPortListSuccess",
                    data: response.data,
                })
            })
            .catch((error) => {
                dispatch({
                    type: "getPortListFailure",
                    error: "ERROR"
                })
            })
    }
}
export const postPortDetails = (data) => {
    let url = `${API.postPort}`;
    return dispatch => {
        axios.post(url, data)
            .then((response) => {
                dispatch(getPortList(searchData));
                dispatch({
                    type: "postPortDetailSuccess",
                    data: response.data,
                })
            })
            .catch((error) => {
                dispatch({
                    type: "postPortDetailFailure",
                    error: "ERROR"
                })
            })
    }
}
export const putPortDetails = (data) => {
    let url = `${API.postPort}`;
    return dispatch => {
        axios.put(url, data)
            .then((response) => {
                dispatch(getPortList(searchData));
                dispatch({
                    type: "putPortDetailSuccess",
                    data: response.data,
                })
            })
            .catch((error) => {
                dispatch({
                    type: "putPortDetailFailure",
                    error: "ERROR"
                })
            })
    }
}
export const deletePortDetails = (data) => {
    let url = `${API.postPort}`;
    return dispatch => {
        axios.put(url, data)
            .then((response) => {
                dispatch(getPortList(searchData));
                dispatch({
                    type: "deletePortDetailSuccess",
                    data: response.data,
                })
            })
            .catch((error) => {
                dispatch({
                    type: "deletePortDetailFailure",
                    error: "ERROR"
                })
            })
    }
}
/* export const getPortTypeList = () => {
    let url = `${API.GetPortTypeList}`;
    return (dispatch) => {
      axios
        .get(url)
        .then((response) => {
          dispatch({
            type: "getPortTypeListSuccess",
            data: response.data,
          });
        })
        .catch((error) => {
          dispatch({
            type: "getPortTypeListFailure",
            error: "ERROR",
          });
        });
    };
  }; */